import React, { useEffect, useState, useCallback } from 'react';
import api from '../../services/api';

const fmtHora = d => new Date(d).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

// Painel do administrador: solicitações de liberação pendentes (módulo de
// liberação de senhas). Aprovar destrava o fluxo do solicitante; recusar
// exige motivo, mostrado a ele.
export default function PainelLiberacoes({ onClose, onChange }) {
  const [lista, setLista] = useState(null);
  const [ocupado, setOcupado] = useState(false);

  const carregar = useCallback(async () => {
    try { const { data } = await api.get('/liberacoes/pendentes'); setLista(data); }
    catch { setLista([]); }
  }, []);

  useEffect(() => {
    carregar();
    const t = setInterval(carregar, 5000);
    return () => clearInterval(t);
  }, [carregar]);

  const responder = async (id, aprovar) => {
    let motivo = null;
    if (!aprovar) {
      motivo = window.prompt('Motivo da recusa (será mostrado ao solicitante):');
      if (motivo === null) return;
      if (!motivo.trim()) { alert('Informe o motivo da recusa.'); return; }
    }
    setOcupado(true);
    try {
      await api.post(`/liberacoes/${id}/${aprovar ? 'aprovar' : 'recusar'}`,
        aprovar ? {} : { motivo: motivo.trim() });
      await carregar();
      onChange?.();
    } catch (err) {
      alert(err.response?.data?.erro || 'Erro ao responder a solicitação.');
    } finally { setOcupado(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', zIndex: 9999,
      display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: 70 }}
      onMouseDown={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: '#fff', borderRadius: 6, width: 560, maxWidth: '94vw',
        boxShadow: '0 10px 40px rgba(0,0,0,.4)', overflow: 'hidden' }}>
        <div style={{ background: '#0f2557', color: '#fff', padding: '10px 14px',
          fontSize: 13, fontWeight: 700, display: 'flex', justifyContent: 'space-between' }}>
          <span>🔓 Solicitações de liberação pendentes</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#fff',
            cursor: 'pointer', fontSize: 15, lineHeight: 1 }}>✕</button>
        </div>
        <div style={{ maxHeight: 380, overflowY: 'auto' }}>
          {lista === null && <div style={{ padding: 18, fontSize: 13, color: '#666' }}>Carregando…</div>}
          {lista?.length === 0 && (
            <div style={{ padding: 18, fontSize: 13, color: '#666' }}>
              Nenhuma solicitação pendente. ✔
            </div>
          )}
          {lista?.map(l => (
            <div key={l.id} style={{ padding: '10px 14px', borderBottom: '1px solid #e5e7eb',
              display: 'flex', gap: 10, alignItems: 'center' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#111827' }}>
                  #{l.id} · {l.acao}
                  <span style={{ fontWeight: 400, color: '#6b7280' }}> — {fmtHora(l.criado_em)}</span>
                </div>
                <div style={{ fontSize: 12, color: '#374151' }}>
                  Solicitante: <strong>{l.usuario_nome || l.usuario_id || '—'}</strong>
                </div>
                {l.detalhes && (
                  <div style={{ fontSize: 12, color: '#6b7280', whiteSpace: 'pre-wrap' }}>{l.detalhes}</div>
                )}
              </div>
              <button disabled={ocupado} onClick={() => responder(l.id, true)}
                style={{ height: 28, padding: '0 12px', border: '1px solid #166534', borderRadius: 4,
                  background: '#dcfce7', color: '#166534', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                ✔ Liberar
              </button>
              <button disabled={ocupado} onClick={() => responder(l.id, false)}
                style={{ height: 28, padding: '0 12px', border: '1px solid #b91c1c', borderRadius: 4,
                  background: '#fee2e2', color: '#b91c1c', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                ✘ Recusar
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
